export default "__VITE_ASSET__D900xJlV__"